import { render } from "./MobileMenu.vue?vue&type=template&id=5ea538c5&ts=true"
import script from "./MobileMenu.vue?vue&type=script&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&lang=ts"

import "./MobileMenu.vue?vue&type=style&index=0&id=5ea538c5&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__